import { useIntl } from 'react-intl';
import { Group, Stack, Text, Button } from '@mantine/core';

interface DigiStorageAccountProps {
  email?: string;
  hasToken: boolean;
  onGenerateToken: () => void;
}

export const DigiStorageAccount = ({
  email,
  hasToken,
  onGenerateToken,
}: DigiStorageAccountProps) => {
  const intl = useIntl();

  return (
    <Group gap="md" align="center">
      <img
        src="/digi-storage-logo.png"
        alt="DigiStorage"
        style={{ height: '40px', width: 'auto' }}
      />
      <Stack gap={4}>
        {hasToken ? (
          <>
            <Text size="sm" fw={500}>
              {intl.formatMessage({ id: 'digiStorageAccount' })}
            </Text>
            <Text fw={700}>{email || ''}</Text>
          </>
        ) : (
          <Button
            size="xs"
            color="green"
            onClick={onGenerateToken}
            style={{ width: 'auto' }}
          >
            {intl.formatMessage({ id: 'authenticateWithDigiStorage' })}
          </Button>
        )}
      </Stack>
    </Group>
  );
};
